import { apiFetch, getSessionId as getBaseSessionId } from "@/integrations/supabase/client";
import { announceLegacySessionId } from "@/lib/legacySessionBridge";
import type { Database } from "@/integrations/supabase/types";
import type { Stem } from "@/types/stem";

type StemSession = Database["public"]["Tables"]["stem_sessions"]["Row"];
type StemSessionInsert = Database["public"]["Tables"]["stem_sessions"]["Insert"];
export type SessionType = "stem" | "acapella" | "drum";

export const getSessionId = () => {
  const sessionId = getBaseSessionId();
  announceLegacySessionId(sessionId);
  return sessionId;
};

export const setSessionIdHeader = async () => {
  return getSessionId();
};

const toQuery = (params: Record<string, string>) => `?${new URLSearchParams(params).toString()}`;

export const fetchSessions = async (type: SessionType = "stem"): Promise<StemSession[]> => {
  const sessionId = getSessionId();
  console.log("Fetching sessions for session:", sessionId);

  const res = await apiFetch(`/sessions${toQuery({ type })}`);
  const data = await res.json();
  console.log("Fetched sessions:", data);
  return data as StemSession[];
};

export const createSession = async (
  sessionData: Omit<StemSessionInsert, "session_id"> & { type: SessionType },
): Promise<StemSession> => {
  const sessionId = getSessionId();
  console.log("Creating session with ID:", sessionId);

  const res = await apiFetch("/sessions", {
    method: "POST",
    body: JSON.stringify(sessionData),
  });
  const data = await res.json();
  console.log("Created session:", data);
  return data as StemSession;
};

export const updateSession = async ({
  id,
  stems,
  status = "completed",
  processing_minutes,
}: {
  id: string;
  stems: Stem[];
  status?: string;
  processing_minutes?: number;
}): Promise<void> => {
  console.log("Updating session:", { id, stems, status, processing_minutes });

  await apiFetch(`/sessions/${id}`, {
    method: "PATCH",
    body: JSON.stringify({ stems, status, processing_minutes }),
  });

  console.log("Session updated successfully");
};

export const deleteSession = async (sessionId: string): Promise<void> => {
  console.log("Deleting session:", sessionId);

  await apiFetch(`/sessions/${sessionId}`, {
    method: "DELETE",
  });

  console.log("Session deleted successfully");
};

export const checkExistingSession = async (filename: string, type: SessionType) => {
  const sessionId = getSessionId();
  console.log("Checking existing session for file:", filename);

  const res = await apiFetch(`/sessions/check-existing${toQuery({ filename, type })}`);
  const data = await res.json();
  console.log("Existing session check result:", data);
  return data as StemSession | null;
};
